import { Consolidator } from '@modules/auth/interfaces/consolidator.response.dto';

/**
 * Avisos de Emisiones: se muestran una vez por ingreso a la plataforma, a todos
 * los usuarios salvo las agencias hijas de Grupo 8 (hora Argentina).
 * - "announcement" (CAT-5153): jueves 22/10 00:00 al sábado 24/10 23:59.
 * - "dates" (CAT-5181): domingo 25/10 00:00 al martes 27/10 23:59.
 */
export const GRUPO8_CONSOLIDATOR_ID = '67cb4e4176188430c12ffd78';

export type EmissionsNoticeVariant = 'announcement' | 'dates';

const NOTICE_WINDOWS: { variant: EmissionsNoticeVariant; start: Date; end: Date }[] = [
  {
    variant: 'announcement',
    start: new Date('2026-10-22T00:00:00-03:00'),
    end: new Date('2026-10-25T00:00:00-03:00'),
  },
  {
    variant: 'dates',
    start: new Date('2026-10-25T00:00:00-03:00'),
    end: new Date('2026-10-28T00:00:00-03:00'),
  },
];

const PENDING_KEY = 'emissionsNoticePending';

export function getEmissionsNoticeVariant(
  now: Date = new Date(),
): EmissionsNoticeVariant | null {
  const window = NOTICE_WINDOWS.find((w) => now >= w.start && now < w.end);
  return window?.variant ?? null;
}

export function isGrupo8ChildAgency(consolidators: Consolidator[]): boolean {
  return consolidators.some((c) => c.consolidatorId === GRUPO8_CONSOLIDATOR_ID);
}

/** Se llama en cada login: el aviso queda pendiente para la próxima pantalla. */
export function markEmissionsNoticePending(): void {
  localStorage.setItem(PENDING_KEY, 'true');
}

/** Devuelve si había un aviso pendiente y lo consume: solo una vez por login. */
export function consumeEmissionsNoticePending(): boolean {
  const pending = localStorage.getItem(PENDING_KEY) === 'true';
  localStorage.removeItem(PENDING_KEY);
  return pending;
}
